var DEFAULT_HTTP_TIMEOUT=12e4;export{DEFAULT_HTTP_TIMEOUT};